const AppSettings = {
  autoRefreshMax: (): number => Number(process.env.REACT_APP_AUTOREFRESH_MAX) || 30,
  autoRefreshSeconds: (): number => Number(process.env.REACT_APP_AUTOREFRESH_SECONDS) || 60,
};

export default AppSettings;
